





































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { User } from "@/components/User";
import { News } from "@/components/News";
import { INews } from "@/components/shared/types";

const TEST_DATA:any = [{
      id: 1,
      title: 'GISTDA ร่วมกับสำนักส่งเสริมและถ่ายทอดเทคโนโลยี (ศวภ.2) จัดฝึกอบรมเชิงปฏิบัติการ “การใช้งานระบบบริการภูมิสารสนเทศเพื่อการเกษตร (GISagro) เพื่อการจัดทำแผนที่พื้นที่ปลูกยางพารา” เพื่อสนับสนุนการแก้ไขปัญหายางพาราตามนโยบายภาครัฐ ณ ศูนย์คอมพิวเตอร์ มหาวิทยาลัยราชภัฏอุดรธานี จังหวัดอุดรธานี  โดยมีหลายหน่วยงานเข้าร่วมอบรมด้วย ได้แก่ สำนักงานเกษตรจังหวัดอุดรธานีองค์การบริหารส่วนตำบล (อบต.) ในจังหวัดอุดรธานี สำนักงานกองทุนสงเคราะห์การทำสวนยาง (สกย.) จังหวัดอุดรธานี และศูนย์ภูมิภาคเทคโนโลยีอวกาศและภูมิสารสนเทศ ภาคตะวันออกเฉียงเหนือ ซึ่งมีผู้เข้าร่วมอบรมทั้งสิ้น 30 คน',
      start_dt: '2018-02-25',
      end_dt: '2018-02-27',
      contents: [{
        media_path: '/static/images/news_Udon1.png',
        text: 'ช่วงเช้า ผู้ว่าราชการจังหวัดอุดรธานี <b>"<u>นายนพวัชร สิงห์ศักดา</u>"</b> เป็นประธานกล่าวเปิดงานการฝึกอบรมการใช้งานระบบบริการภูมิสารสนเทศเพื่อการเกษตร (GISagro) เพื่อการจัดทำจัดทำแผนที่ปลูกยางพารารายแปลงด้วยเทคโนโลยีภูมิสารสนเทศ'
      },{
        media_path: '/static/images/news_Udon2.png',
        text: 'จากนั้นวิทยากรแนะนำหน่วยงานและบรรยายบทบาทของ GISTDA ในการประยุกต์ใช้เทคโนโลยีภูมิสารสนเทศในการบริหารจัดการภาคการเกษตร พร้อมทั้งวิทยากรให้คำแนะนำการใช้งานระบบบริการภูมิสารสนเทศเพื่อการเกษตร (GISagro) โดยอธิบายการวาดแปลงเพาะปลูก การกรอกข้อมูลรายละเอียดแปลงและข้อมูลเกษตรกร'
      }]
    },{
      id: 2,
      title: 'GISTDA ร่วมกับสำนักงานเกษตรจังหวัด จัดอบรมหลักสูตร “การจัดทำผังแปลงเกษตรกรรม (วาดแปลง) โดยโปรแกรม GISAGRO จังหวัดศรีสะเกษ” ระหว่างวันที่ 8-9 มกราคม 2561',
      start_dt: '2018-01-08',
      end_dt: '2018-01-09'
    },{
      id: 3,
      title: 'GISTDA ร่วมกับสำนักงานเกษตรจังหวัด จัดอบรมหลักสูตร “การจัดทำผังแปลงเกษตรกรรม (วาดแปลง) โดยโปรแกรม GISAGRO” ระหว่างวันที่ 3-4 มกราคม 2561',
      start_dt: '2018-01-03',
      end_dt: '2018-01-04'
    },{
      id: 4,
      title: 'GISTDA ร่วมกับสำนักงานสหกรณ์จังหวัดลำปาง จัดทำฐานข้อมูลเชิงพื้นที่แปลงปลูกสับปะรด ต.บ้านเสด็จ อ.เมืองลำปาง จ.ลำปาง  ระหว่างวันที่ 9-14 ตุลาคม 2560',
      start_dt: '2017-10-09',
      end_dt: '2017-10-14'
    },{
      id: 5,
      title: 'GISTDA ร่วมกับสำนักงานสหกรณ์จังหวัดลำปาง จัดอบรมโครงการเพิ่มประสิทธิภาพและประสิทธิผลทางการเกษตรด้วยเทคโนโลยีสารสนเทศ วันที่ 6-8 กันยายน 2560 ณ ห้องปฏิบัติการคอมพิวเตอร์ มหาวิทยาลัยเทคโนโลยีราชมงคลล้านนาลำปาง',
      start_dt: '2017-09-06',
      end_dt: '2017-09-08'
    },{
      id: 6,
      title: 'GISTDA ร่วมกับ จังหวัดกาฬสินธุ์ จัดฝึกอบรมเพื่อเพิ่มประสิทธิภาพและประสิทธิผลด้านการเกษตรของจังหวัดฯ',
      start_dt: '2017-08-16',
      end_dt: '2017-08-17'
    },{
      id: 7,
      title: 'GISTDA ร่วมกับ เทศบาลตำบลท่าผา อำเภอแม่แจ่ม จังหวัดเชียงใหม่ ศูนย์ประสานงานกระทรวงวิทยาศาสตร์และเทคโนโลยี ประจำภูมิภาค ภาคเหนือตอนบน (ศวภ.1) จัดฝึกอบรม หลักสูตร การใช้งานระบบภูมิสารสนเทศเพื่อบริหารจัดการเกษตรเชิงพื้นที่',
      start_dt: '2017-08-10',
      end_dt: '2017-08-10'
    }];

@Component
export default class NewsUI extends Vue {
  newsList:News[] = [];

  get User() : User {
    return this.$store.getters.User;
  }

  async created() {
    try {
      let data = await this.User.requestResource('mis/news');
      this.newsList = data.map((news) => {
        let ns:News = new News();
        ns.PropertiesFromStorage = news;
        if (ns.isNew) {
          ns.getContents(this.User);
        }
        return ns;
      });
    } catch (error) {
      if (error.id=='no_content') {
        this.newsList = [];
      }
    }
  }

  showHideDetails(news:News) {
    for (let i=0; i<this.newsList.length; i++) {
      if (this.newsList[i].shown && 
        this.newsList[i].HalloId!=news.HalloId) {
        this.newsList[i].shown = false;
        break;
      }
    }
    news.shown = !news.shown;
  }

  getNewsContents(news:News) {
    news.getContents(this.User);
  }

  addNews() {
    this.$emit('changeMenu', {
      name: 'adminaddnews'
    });
  }
}
